import React from "react";
import { useParams, Link, useSearchParams } from "react-router-dom";
import Layout from "../components/Layout";
import { ADDON_CATEGORIES } from "../data/content";

const tabs = [
  { key: "fees", label: "Fees" },
  { key: "exterior", label: "Exterior" },
  { key: "interior", label: "Interior" },
  { key: "signature", label: "Signature" },
];

export default function AddOns() {
  const { category } = useParams();
  const [sp] = useSearchParams();
  const highlight = sp.get("highlight");
  const cat = ADDON_CATEGORIES[category] ? category : "exterior";
  const data = ADDON_CATEGORIES[cat];
  return (
    <Layout>
      <section className="max-w-5xl mx-auto px-6 py-16 md:py-24">
        <p className="text-xs tracking-[0.3em] uppercase text-pink-500 font-bold mb-4">Add-ons & Upgrades</p>
        <h1 className="text-4xl md:text-6xl font-extrabold tracking-tighter">{data.title}</h1>
        <p className="text-zinc-400 mt-4 max-w-2xl text-lg">{data.intro}</p>

        <Link to="/book" className="mt-6 inline-flex items-center gap-2 bg-pink-600/90 hover:bg-pink-500 rounded-full px-6 py-3 text-sm font-semibold transition-colors" data-testid="addons-return-booking">← Return to booking</Link>

        <div className="mt-8 flex flex-wrap gap-3">
          {tabs.map((t) => {
            const attn = highlight === t.key && cat !== t.key;
            return (
              <Link key={t.key} to={`/add-ons/${t.key}`} className={`rounded-full px-5 py-2.5 text-sm font-semibold transition-all ${cat === t.key ? "bg-pink-600 text-white" : "border border-white/20 text-zinc-300 hover:border-white/40"} ${attn ? "ring-4 ring-pink-500 scale-125 animate-bounce bg-pink-600 text-white shadow-lg shadow-pink-500/50" : ""}`} data-testid={`addon-tab-${t.key}`}>{t.label}{attn ? " 👈" : ""}</Link>
            );
          })}
        </div>

        <div className="mt-10 grid gap-5 md:grid-cols-2">
          {data.items.map((it, i) => (
            <div key={i} className="rounded-2xl border border-white/10 bg-[#121212] p-6" data-testid={`addon-item-${cat}-${i}`}>
              <div className="flex items-start justify-between gap-4">
                <h3 className="text-lg font-bold">{it.name}</h3>
                <span className="text-pink-500 font-extrabold whitespace-nowrap">{it.price}</span>
              </div>
              <p className="text-sm text-zinc-400 mt-3 leading-relaxed">{it.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-14 flex gap-4 flex-wrap">
          <Link to="/book" target="_blank" rel="noopener noreferrer" className="bg-pink-600 hover:bg-pink-500 text-white font-semibold rounded-full px-8 py-4 transition-colors active:scale-95" data-testid="addons-book-btn">Add these to a booking</Link>
          <Link to="/pricing" className="border border-white/25 hover:border-white/50 rounded-full px-8 py-4 transition-colors">Back to pricing</Link>
        </div>
      </section>
    </Layout>
  );
}
